import { gql } from '@apollo/client'
import { Button } from '@farol-ds/react'
import { LoginTrigger } from '@jusbrasil-web/shared-bifrost'
import { useBoxModal as useBoxLock } from '@jusbrasil-web/shared-box-lock'
import { ReactNode } from 'react'

import { FEATURE_CODES } from '../../constants'
import { UnlockCaseLawInformation_ViewerFragment } from './__generated__/unlock-case-law-information.graphql'

export interface UnlockCaseLawInformationProps {
  buttonLabel: string
  children?: ReactNode
  fromComponent: string
  resourceId: string
  viewer: UnlockCaseLawInformation_ViewerFragment | null
}

export function UnlockCaseLawInformation(props: UnlockCaseLawInformationProps) {
  const { buttonLabel, children, fromComponent, resourceId, viewer } = props

  const boxLockProps = {
    boxOptions: { resource_id: resourceId },
    featureCode: FEATURE_CODES.UNLOCK_CASE_LAW_INFORMATION,
    fromComponent,
    appId: 'web-docview',
    pageMetadata: {},
  }

  const { setOpen } = useBoxLock({ ...boxLockProps, viewer })

  const handleClick = () => {
    if (viewer) {
      setOpen(true)
    }
  }

  return (
    <LoginTrigger
      isLogged={!!viewer}
      options={{
        eventData: {
          feature_code: boxLockProps.featureCode,
          from_component: boxLockProps.fromComponent,
        },
      }}
    >
      {viewer?.hasUnlockedCaseLawInformation ? (
        children
      ) : (
        <Button kind="plain" onClick={handleClick}>
          {buttonLabel}
        </Button>
      )}
    </LoginTrigger>
  )
}

UnlockCaseLawInformation.fragments = {
  viewer: gql`
    fragment UnlockCaseLawInformation_viewer on Profile {
      hasUnlockedCaseLawInformation
      ...useBoxModal_viewer
    }
    ${useBoxLock.fragments.viewer}
  `,
}
